import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumbs, BreadcrumbItem } from '@vnetwork/ui/layout';

/**
 * Shared breadcrumb trail for account sub-pages: `Account › <current>`, with the
 * `Account` crumb linking back to the account hub (`/account`). Passed to
 * `PageHeader`'s `breadcrumbs` slot so every account page shows a consistent
 * trail (the account hub itself omits it — it is the root).
 */
export function AccountBreadcrumbs({ current }: { current: ReactNode }) {
  return (
    <Breadcrumbs>
      <BreadcrumbItem asChild>
        <Link to="/account">Account</Link>
      </BreadcrumbItem>
      <BreadcrumbItem current>{current}</BreadcrumbItem>
    </Breadcrumbs>
  );
}
